import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Fri Oct 19 2018
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { ApplicationConfiguration } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { LoadingState } from '../../api/LoadingState';
import { GeneralConfigurationsLayer } from '../../transportLayers/general-configurations/GeneralConfigurationsLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * This store obtaining data of tiers.
 */

export var GeneralConfigurationsStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(GeneralConfigurationsStore, _BaseStore);

  function GeneralConfigurationsStore() {
    var _this;

    _classCallCheck(this, GeneralConfigurationsStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GeneralConfigurationsStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.GeneralConfigurations; // Change this state when all data are ready (or fetching failed).

    _this.loadingState = LoadingState.Pending;
    /** layer contains methods for fletching data */

    _this.GeneralConfigurationsLayer = new GeneralConfigurationsLayer(); // FIXME: Why is boolean in localStorage converted to and from string?

    _this.menuExpanded = localStorage.getItem("menuExpanded") && localStorage.getItem("menuExpanded").toString() == "true" ? true : false;
    _this.menuOpened = [];

    _this.toggleMenu = function () {
      _this.menuExpanded = localStorage.getItem("menuExpanded") && localStorage.getItem("menuExpanded").toString() == "true" ? false : true;
      localStorage.setItem("menuExpanded", _this.menuExpanded.toString());
    };

    return _this;
  }
  /** Toggles open state of items */


  _createClass(GeneralConfigurationsStore, [{
    key: "toggleMenuItem",
    value: function toggleMenuItem(name) {
      if (this.menuOpened.includes(name)) {
        this.menuOpened.splice(this.menuOpened.indexOf(name), 1);
      } else {
        this.menuOpened.push(name);
      }
    }
    /**
     * Fletches all configurations
     * returns a promise with Map of all Tiers
     */

  }, {
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.GeneralConfigurationsLayer.findAll().then(function (configuration) {
        runInAction(function () {
          _this2.loadingState = LoadingState.Success;
          _this2.config = configuration;
        });
        return configuration;
      });
    }
  }]);

  return GeneralConfigurationsStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Number)], GeneralConfigurationsStore.prototype, "loadingState", void 0);

__decorate([observable, __metadata("design:type", ApplicationConfiguration)], GeneralConfigurationsStore.prototype, "config", void 0);

__decorate([observable, __metadata("design:type", Boolean)], GeneralConfigurationsStore.prototype, "menuExpanded", void 0);

__decorate([observable, __metadata("design:type", Array)], GeneralConfigurationsStore.prototype, "menuOpened", void 0);

__decorate([action, __metadata("design:type", Object)], GeneralConfigurationsStore.prototype, "toggleMenu", void 0);

__decorate([action, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], GeneralConfigurationsStore.prototype, "toggleMenuItem", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], GeneralConfigurationsStore.prototype, "getAll", null);